// TODO: Pause slides on mobile
// TODO: Pause slides on hover if not on mobile
// TODO: Load images when slide is active
// TODO: Check if the mouseouts are happening only to the parent.
//       I suspect its only working because more mouseovers fire to override
(function() {
  class Carousel {
    constructor(root_element) {
      this.root_element = root_element;
      this.slide_length_seconds = parseInt(root_element.dataset.slideLength || '10', 10);
      if (isNaN(this.slide_length_seconds)) {
        this.slide_length_seconds = 10;
      }

      this.disable_auto_slide = false;
      if (root_element.dataset.autoSlide === 'off') {
        this.disable_auto_slide = true;
      }

      this.slide_timeout = null;
      this.mouseover_handler = (e) => this.handleMouseOver(e);
      this.mouseout_handler = (e) => this.handleMouseOut(e);

      this.headings = root_element.querySelectorAll('.js-quote-carousel__headings *');
      this.slide_links = root_element.querySelectorAll('.js-quote-carousel__slide-links *');
      this.slides = root_element.querySelectorAll('.js-quote-carousel__slide');

      this.active_slide_id = '';
      this.slide_id_order = [];
      for (let i = 0; i < this.slide_links.length; i++) {
        const link = this.slide_links[i];

        if (link.classList.contains('is-active')) {
          this.active_slide_id = link.dataset.forSlideId;
        }

        this.slide_id_order.push(link.dataset.forSlideId);
      };

      this.addListenersToSlideLinks();;

      if (!this.disable_auto_slide) {
        this.startSlideTimer();
        this.listenForMouseOver();
      }
    }

    addListenersToSlideLinks() {
      for (let i = 0; i < this.slide_links.length; i++) {
        const link = this.slide_links[i];
        link.addEventListener('click', () => {
          // Manually clicking a slide means we should disable the auto turner
          this.killMouseListeners();
          this.stopSlideTimer();
          this.activateSlide(link.dataset.forSlideId);
        });
      }
    }

    activateSlide(slide_id) {
      this.active_slide_id = slide_id;

      this.activateElement(this.headings, slide_id);
      this.activateElement(this.slide_links, slide_id);
      this.activateElement(this.slides, slide_id);
    }
    activateElement(elements, slide_id) {
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        if (element.dataset.forSlideId !== slide_id) {
          element.classList.remove('is-active');
          continue;
        }

        element.classList.add('is-active');
      }
    }

    getCurrentSlideIndex() {
      let slide_index = this.slide_id_order.indexOf(this.active_slide_id);
      if (slide_index < 0) {
        slide_index = 0;
      }

      return slide_index;
    }
    goToPreviousSlide() {
      const slide_index = this.getCurrentSlideIndex();

      let prev_index = slide_index - 1;
      if (prev_index < 0) {
        prev_index = this.slide_id_order.length - 1;
      }

      this.activateSlide(this.slide_id_order[prev_index]);
    }
    goToNextSlide() {
      const slide_index = this.getCurrentSlideIndex();

      let next_index = slide_index + 1;
      if (next_index >= this.slide_id_order.length) {
        next_index = 0;
      }

      this.activateSlide(this.slide_id_order[next_index]);
    }

    startSlideTimer() {
      if (this.disable_auto_slide) {
        return;
      }

      if (this.slide_timeout) {
        clearTimeout(this.slide_timeout);
      }

      this.slide_timeout = setTimeout(
          () => this._slideTimerFinish(),
          this.slide_length_seconds * 1000);
    }
    _slideTimerFinish() {
      this.goToNextSlide();
      this.startSlideTimer();
    }
    stopSlideTimer() {
      if (this.slide_timeout) {
        clearTimeout(this.slide_timeout);
      }
    }

    listenForMouseOver() {
      this.root_element.addEventListener('mouseover', this.mouseover_handler, true);
    }
    listenForMouseOut() {
      this.root_element.addEventListener('mouseout', this.mouseout_handler, false);
    }
    killMouseListeners() {
      this.root_element.removeEventListener('mouseover', this.mouseover_handler, true);
      this.root_element.removeEventListener('mouseout', this.mouseout_handler, false);
    }

    handleMouseOver() {
      this.killMouseListeners();
      this.stopSlideTimer();
      this.listenForMouseOut();
    }
    handleMouseOut() {
      this.killMouseListeners();
      this.startSlideTimer();
      this.listenForMouseOver();
    }
  }

  function main() {
    const carousels = document.querySelectorAll('.js-quote-carousel');
    for (let i = 0; i < carousels.length; i++) {
      new Carousel(carousels[i]);
    }
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
